export const API_BASE_URL = '/ada-api/v2';
export const ADMIN_ROUTE_PREFIX = 'admin';

export const DEFAULT_FROM_EMAIL = 'ada@nand.io';
export const DEFAULT_HOSTNAME = 'depi-next.nand-projects.io';

export const DEFAULT_INVITE_TEMPLATE_ID = 18559792;
export const DEFAULT_CREATE_ACCOUNT_TEMPLATE_ID = 18560222;
export const DEFAULT_CHANGE_PASSWORD_TEMPLATE_ID = 18559727;
export const DEFAULT_FORGOT_PASSWORD_TEMPLATE_ID = 18560344;

// not used
export const DEFAULT_REGISTER_USER_TEMPLATE_ID = 4136083;
export const DEFAULT_DELETE_ACCOUNT_TEMPLATE_ID = 18559754;
export const DEFAULT_CHANGE_EMAIL_TEMPLATE_ID = 18559911;

export const POSTMARK_FROM = process.env.POSTMARK_FROM || DEFAULT_FROM_EMAIL;
export const POSTMARK_HOSTNAME =
  process.env.POSTMARK_HOSTNAME || DEFAULT_HOSTNAME;
export const POSTMARK_INVITE_TEMPLATE_ID =
  process.env.POSTMARK_INVITE_TEMPLATE_ID || DEFAULT_INVITE_TEMPLATE_ID;
export const POSTMARK_CREATE_ACCOUNT_TEMPLATE_ID =
  process.env.POSTMARK_CREATE_ACCOUNT_TEMPLATE_ID ||
  DEFAULT_CREATE_ACCOUNT_TEMPLATE_ID;
export const POSTMARK_CHANGE_PASSWORD_TEMPLATE_ID =
  process.env.POSTMARK_CHANGE_PASSWORD_TEMPLATE_ID ||
  DEFAULT_CHANGE_PASSWORD_TEMPLATE_ID;
export const POSTMARK_FORGOT_PASSWORD_TEMPLATE_ID =
  process.env.POSTMARK_FORGOT_PASSWORD_TEMPLATE_ID ||
  DEFAULT_FORGOT_PASSWORD_TEMPLATE_ID;
export const POSTMARK_REGISTER_USER_TEMPLATE_ID =
  process.env.POSTMARK_REGISTER_USER_TEMPLATE_ID ||
  DEFAULT_REGISTER_USER_TEMPLATE_ID;
export const POSTMARK_DELETE_ACCOUNT_TEMPLATE_ID =
  process.env.POSTMARK_DELETE_ACCOUNT_TEMPLATE_ID ||
  DEFAULT_DELETE_ACCOUNT_TEMPLATE_ID;
export const POSTMARK_CHANGE_EMAIL_TEMPLATE_ID =
  process.env.POSTMARK_CHANGE_EMAIL_TEMPLATE_ID ||
  DEFAULT_CHANGE_EMAIL_TEMPLATE_ID;
